import { action, extendObservable } from 'mobx';
import FetchService from '../../../core/services/FetchService';

class LoadUnitItemService {
  fetch = new FetchService();

  constructor() {
    extendObservable(this, {
      unitItem: null,
    });
  }

  handleLoad = action(async (moduleId, unitId, itemId) => {
    Promise.all([
      this.fetch.fetch({
        url: `/units/${unitId}/items/${itemId}`,
      }),
      this.fetch.fetch({
        url: `/modules/${moduleId}/units/${unitId}`,
      }),
    ]).then(([{ item, order, group }, unit]) => {
      this.unitItem = {
        order,
        group,
        item,
        unit,
      };
    });
  });
}

export default LoadUnitItemService;
